
const state = {
  export_format: '',
  external_ftp: {},
  id: null,
  import_format: '',
  internal_ftp: {},
  options: {},
  password: '',
  short_code: '',
  title: '',
  username: '',
}

export const requiredFields = [
  { key: 'title' },
  { key: 'short_code' },
]

export default state
